// extracted by mini-css-extract-plugin
module.exports = {"Title":"Container_Title__qNGip","Container":"Container_Container__p0u2E"};